// Used through the app to list user related actions
// to update values in the store

// METHODS
// ---- Update user email
export const updateUserEmail = (newUserEmail) => ({
    type: 'updateUserEmail', // Action type referenced in store
    payload: newUserEmail,   // New value for the state to update
});

// ---- Clean user email
export const cleanUserEmail = () => ({
    type: 'cleanUserEmail', // Action type referenced in store
    payload: null,   // New value for the state to update
});